import React from 'react';
import LoginForm from './LoginForm';

const LoginCard = () => {
  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center p-4 md:p-0">
      <div className="w-full max-w-md">
        {/* Main Login Card with Enhanced Contrast */}
        <div className="bg-white/95 backdrop-blur-md border-2 border-spiritual-gold/30 rounded-2xl shadow-2xl p-4 md:p-4 relative overflow-hidden">
          {/* High Contrast Background Overlay */}
          <div className="absolute inset-0 bg-white/90" />
          <div className="absolute inset-0 bg-gradient-to-br from-white/95 via-spiritual-light/10 to-white/95" />
          
          {/* Enhanced Header Accent with Better Contrast */}
         
          {/* Login Form with Enhanced Contrast */}
          <div className="relative z-10">
            <LoginForm />
          </div>

          {/* Enhanced Footer with Better Contrast */}
          <div className="mt-2 pt-2 border-t-2 border-spiritual-gold/20 text-center relative z-10">
            <div className="bg-white/80 rounded-lg p-2 pb-0">
              <p className="text-xs text-gray-700 font-medium">
                © {new Date().getFullYear()} Tamil Nadu Prasanthi Seva Organization
              </p>
              <p className="text-xs text-spiritual-orange font-semibold mt-1">
                Serving with Love and Devotion
              </p>
            </div>
          </div>
        </div>

        {/* Subtle Decorative Elements */}
        <div className="absolute -z-10 top-4 left-4 w-48 h-48 bg-spiritual-blue/5 rounded-full blur-2xl" />
        <div className="absolute -z-10 bottom-4 right-4 w-64 h-64 bg-spiritual-purple/5 rounded-full blur-2xl" />
        <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-56 h-56 bg-spiritual-gold/5 rounded-full blur-2xl" />
        
        {/* Minimal Floating Elements */}
        <div className="absolute -top-4 -right-4 w-6 h-6 bg-spiritual-teal/40 rounded-full opacity-50 spiritual-float" />
        <div className="absolute -bottom-4 -left-4 w-4 h-4 bg-spiritual-rose/40 rounded-full opacity-40 spiritual-float" style={{animationDelay: '1.5s'}} />
        <div className="absolute top-1/2 -right-6 w-3 h-3 bg-spiritual-amber/40 rounded-full opacity-60 spiritual-float" style={{animationDelay: '0.5s'}} />
      </div>
    </div>
  );
};

export default LoginCard;